import React from 'react';
import axios from 'axios';
import { Input } from '@progress/kendo-react-inputs';
import { ROOT_API_URL } from '../../../../../api-config'
import '../../../../../scss/PublicView/Pages/Home.scss';
import {
    resetPasswordSubmit
} from '../../../../../Redux/Actions/CommonActions.js';
import { connect } from 'react-redux';


class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

    }

    handleSubmit(event) {
        //const response = axios.post('https://tscramembershipportalapi-dev.azurewebsites.net/api/account/ForgotPassword', {

        this.props.resetPasswordSubmit(this.state.email);
        event.preventDefault();
    }

    render() {
        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent reset-password">
                    <div className="container-fluid">
                        <div className="row">
                            <h1 className="col-sm-12">
                                Reset Your Password
                            </h1>
                        
                            <p className="col-sm-12"> 
                                {!this.props.common.emailSent ? `Please enter the email address associated 
                                            with the account that needs the password reset. An email 
                                            will be sent to that account with a link that will take you to
                                            a page where you can set a new password.` : `Password reset email has been sent to ` + this.state.email + `.`}
                            </p>
                        </div>
                        {!this.props.common.emailSent ? 
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-row">
                                    <div className="col-12 form-group">
                                        <label>Email:</label>
                                        <div classname="col-12">
                                            <Input
                                                className="form-control"
                                                type="email"
                                                name="email"
                                                required={true}
                                                id="passwordResetEmail"
                                                value={this.state.email}
                                                placeholder="Email Address"
                                                onChange={this.handleInputChange} />
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="p-0">
                                    <button className='btn btn-primar btnPrimary homeBtn w-100' type="submit" >Send Password Reset Email</button>
                                </div>
                            </form> : null }
                        {this.props.common.error ?
                          <div className="row">
                              <p className="text-danger font-weight-bold col-sm-12"> 
                                  {this.props.common.error ? `We encountered an error sending the password reset email. Please try again.` : null }
                              </p>
                          </div>
                        : null }
                    </div>
                    {/* <div className="container">
                    <div className="row">
                    <form>
                        <input className="w-100"></input>
                    </form>
                    </div>
                    </div> */}

                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        common: state.common
    };
}

export default connect(mapStateToProps, {
    resetPasswordSubmit
})(ResetPassword);